"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _configureStore = require("./stores/configureStore");

var _configureStore2 = _interopRequireDefault(_configureStore);

var _ReservationContainer = require("./container/ReservationContainer");

var _ReservationContainer2 = _interopRequireDefault(_ReservationContainer);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _config = require("./config");

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var root = function root(props) {
  var store = (0, _configureStore2.default)();

  _config2.default.setKey("apiUrl", props.apiUrl);

  _config2.default.setKey("imageUrl", props.imageUrl);

  return _react2.default.createElement(_reactRedux.Provider, {
    store: store
  }, _react2.default.createElement(_ReservationContainer2.default, props));
};

root.defaultProps = {
  apiUrl: "https://servicelister.t8.itt-dev.de/module/api",
  imageUrl: "https://servicelister.t8.itt-dev.de/module/web/Image/ShowImage/"
};
root.propTypes = _extends({}, _ReservationContainer2.default.propTypes, {
  apiUrl: _propTypes2.default.string,
  imageUrl: _propTypes2.default.string
});
exports.default = root;